export default "__VITE_PUBLIC_ASSET__5916877f__"